import { render } from "./InputModal.vue?vue&type=template&id=80be0392&scoped=true&ts=true"
import script from "./InputModal.vue?vue&type=script&lang=ts"
export * from "./InputModal.vue?vue&type=script&lang=ts"

import "./InputModal.vue?vue&type=style&index=0&id=80be0392&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80be0392"]])

export default __exports__